import { render } from "./MontageLogsList.vue?vue&type=template&id=3977f3d6&scoped=true"
import script from "./MontageLogsList.vue?vue&type=script&lang=js"
export * from "./MontageLogsList.vue?vue&type=script&lang=js"

import "./MontageLogsList.vue?vue&type=style&index=0&id=3977f3d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3977f3d6"]])

export default __exports__